<template>
  <!-- Заголовки -->
  <component
    :is="`h${block.data.level}`"
    v-if="block.type === 'header' && block.data.text"
    class="article-post__title"
    :class="`article-post__title--h${block.data.level}`"
    v-html="block.data.text"
  >
  </component>

  <!-- Параграф -->
  <p v-else-if="block.type === 'paragraph' && block.data.text" class="article-post__paragraph" v-html="block.data.text"></p>

  <!-- Разделительная линия -->
  <span v-else-if="block.type === 'blockHr'" class="article-post__hr"></span>

  <!-- Цитаты -->
  <div v-else-if="block.type === 'Quote' && block.data.text" class="article-post__blockquote">
    <blockquote v-html="block.data.text"></blockquote>
    <cite class="article-post__blockquote-author" v-if="block.data.author">{{ block.data.author }}</cite>
    <span class="article-post__blockquote-position" v-if="block.data.position">{{ block.data.position }}</span>
  </div>

  <!-- Списки -->
  <component
    v-else-if="block.type === 'list' && block.data.items.length"
    :is="block.data.style === 'ordered' ? 'ol' : 'ul'"
    class="article-post__list"
    :class="block.data.style === 'ordered' ? 'article-post__list--ol' : 'article-post__list--ul'"
  >
    <li v-for="item in block.data.items" :key="item" class="article-post__list-item" v-html="item"></li>
  </component>

  <!-- Скрытый текст -->
  <div v-else-if="block.type === 'Snippet' && block.data.content" class="article-post__snippet">
    <span @click="snippetOpen = !snippetOpen" class="article-post__snippet-btn" :class="{'article-post__snippet-btn--active': snippetOpen}">{{ block.data.title }} <i
      class="icon-input-droplist"
    ></i></span>
    <div v-if="snippetOpen" class="article-post__snippet-spoiler" v-html="block.data.content"></div>
  </div>

  <!-- Сетка с текстом TextGrid -->
  <div v-else-if="block.type === 'TextGrid'" class="row article-post__textGrid">
    <p
      v-for="(col, i) in block.data.blocks"
      :key="col"
      class="article-post__textGrid-column"
      :class="`col-lg-${block.data.type.split('-')[i]} col-md-6 col-12`"
      v-html="col"
    >
    </p>
  </div>

  <!-- Unsplash -->
  <img v-else-if="block.type === 'unsplash' && block.data.url" :src="block.data.url" :alt="block.data.alt" class="article-post__unsplash">

  <!-- Сноска -->
  <div v-else-if="block.type === 'Callout' && block.data.text" class="article-post__callout" :class="typeCallout">
    <h6 class="article-post__callout-title">{{block.data.type}}</h6>
    <p class="article-post__callout-text" v-html="block.data.text"></p>
  </div>

  <!-- Вложенный файл && block.data.file.url -->
  <div v-else-if="block.type === 'attaches'" class="article-post__attaches">
    <span class="article-post__attaches-title">
      <i class="icon-file_upload"></i>
      {{ block.data.file.url ? block.data.title : 'Ошибка файла' | cut(15) }}
    </span>
    <bim-button :href="block.data.file.url" :disabled="!block.data.file.url" label="Скачать" color="white" small/>
  </div>

  <!-- Картинки -->
  <div v-else-if="block.type === 'ImageGrid' && block.data.url.length <= 4" class="article-post__imageGrid row w-100" ref="contentImage">
    <div
      v-for="img in block.data.url"
      :key="img.url"
      class="article-post__imageGrid-wrapper"
      :class="block.data.url.length > 1 ? 'col-md-6 col-12' : 'col-12'"
    >
      <img
        :src="'/uploads' + img.url + `?size=${imageWidth}x-`"
        :alt="img.alt"
        class="article-post__imageGrid-img"
        @click="$emit('openImageModal', '/uploads' + img.url)"
      />
      <span v-if="img.cap" class="article-post__imageGrid-caption">{{img.cap}}</span>
    </div>
  </div>

  <!-- Таблица -->
  <table
    v-else-if="block.type === 'table' && block.data.content.length"
    class="article-post__table"
    :style="`grid-template-columns: repeat(${block.data.content[0].length}, 1fr);`"
  >
    <tr v-for="(row, i) in block.data.content" :key="i" class="article-post__table-row">
      <td v-for="(cell, i) in row" :key="cell + i" class="article-post__table-cell">{{cell}}</td>
    </tr>
  </table>

  <!-- Таблица характеристик -->
  <table
    v-else-if="block.type === 'tableSpecs' && block.data.content.length"
    class="article-post__table article-post__table-specs"
  >
    <thead>
      <tr class="article-post__table-row">
        <th class="article-post__table-cell header" v-for="(head, i) in block.data.headers" :key="i">{{ head }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, ri) in block.data.content" :key="ri" class="article-post__table-row">
        <template v-if="ri !== 0">
          <td v-for="cell in row" :key="cell + ri" class="article-post__table-cell">{{cell}}</td>
        </template>
      </tr>
    </tbody>
  </table>

  <!-- Слайдер -->
  <div
    class="article-post__slider"
    v-swiper:swiperModel="swiperOption"
    v-else-if="block.type === 'ImageSlider' || (block.type === 'ImageGrid' && block.data.url.length > 4)"
  >
    <div class="swiper-wrapper">
      <div class="swiper-slide article-post__slider-slide" v-for="(slide, index) in block.data.url" :key="index">
        <img :src="'/uploads' + slide.url" :alt="slide.alt" class="article-post__slider-img">
        <span v-if="slide.cap" class="article-post__slider-text caption">
        {{slide.cap}}
      </span>
      </div>
    </div>
    <bim-button
      v-if="$windowWidth >= 961"
      text-color="#4d4d4d"
      color="white"
      icon-size="18"
      rounded
      icon="icon-arrow-left22"
      class="swiper-button-prev article-post__slider-btn"
    />
    <bim-button
      v-if="$windowWidth >= 961"
      text-color="#4d4d4d"
      color="white"
      icon-size="18"
      rounded
      icon="icon-arrow-right22"
      class="swiper-button-next article-post__slider-btn"
    />
  </div>

  <!-- Видео -->
  <div v-else-if="block.type === 'embed'" class="article-post__embed">
    <div class="article-post__embed--height"></div>
    <iframe
      class="article-post__embed--iframe"
      width="100%"
      height="100%"
      :src="block.data.embed"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>

</template>

<script>
import { directive } from 'vue-awesome-swiper'

export default {
  directives: {
    swiper: directive,
  },
  props: {
    block: {
      type: null,
      required: true,
    },
  },
  data () {
    return {
      snippetOpen: false,
      imageWidth: 0,
      swiperOption: {
        spaceBetween: 32,
        loop: true,
        centeredSlides: true,
        grabCursor: true,
        slidesPerView: 1,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  async mounted() {
    if (this.block.type === 'ImageGrid') {

      await this.$nextTick()
      this.calculateImageWidth()
      window.addEventListener("resize", this.calculateImageWidth)
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateImageWidth)
  },
  computed: {
    /**
     * Вычисляет тип сноски
     */
    typeCallout () {
      if (this.block.type === 'Callout') {
        switch (this.block.data.type) {
          case 'Внимание':
            return 'article-post__callout--warning'
          case 'На заметку':
            return 'article-post__callout--toNote'
          case 'Это интересно':
            return 'article-post__callout--interesting'
        }
      }
    },
  },
  methods: {
    calculateImageWidth() {
      const width = this.$refs.contentImage.clientWidth
      if (!width) {
        return setTimeout(this.calculateImageWidth, 100)
      }
      this.imageWidth = width
    }
  },
}
</script>
